import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Wrench, ArrowLeft } from "lucide-react";
import { toast } from "sonner";

export function AuthShell({ title, sub, children }) {
  return (
    <div className="min-h-screen grid lg:grid-cols-2 bg-[#0D0E11]">
      <div className="relative hidden lg:block overflow-hidden blueprint">
        <img src="https://images.unsplash.com/photo-1650127664508-30f4321d9192?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNTl8MHwxfHNlYXJjaHw0fHxleGNhdmF0b3IlMjBjb25zdHJ1Y3Rpb24lMjBtYWNoaW5lcnklMjBkYXJrfGVufDB8fHx8MTc4NTE3NjIyNnww&ixlib=rb-4.1.0&q=85" alt="Machinery" className="absolute inset-0 w-full h-full object-cover opacity-40" />
        <div className="absolute inset-0" style={{ background: "linear-gradient(to right, rgba(13,14,17,0.5), #0D0E11)" }} />
        <div className="relative z-10 p-12 h-full flex flex-col justify-between">
          <Link to="/" className="flex items-center gap-2.5">
            <div className="w-8 h-8 bg-[#FFB800] flex items-center justify-center"><Wrench className="w-5 h-5 text-black" strokeWidth={2.5} /></div>
            <span className="font-head font-900 text-2xl tracking-tight">IRONLOG</span>
          </Link>
          <div>
            <h2 className="font-head font-900 text-6xl uppercase tracking-tighter leading-[0.9]">Keep every<br/><span className="text-[#FFB800]">machine running.</span></h2>
            <p className="font-body text-[#94A3B8] mt-4 max-w-sm">The rugged command center for your whole fleet.</p>
          </div>
        </div>
      </div>
      <div className="flex items-center justify-center p-6 md:p-12">
        <div className="w-full max-w-md">
          <Link to="/" className="lg:hidden flex items-center gap-2 text-[#94A3B8] mb-8 font-body text-sm"><ArrowLeft className="w-4 h-4" /> Back home</Link>
          <h1 className="font-head font-900 text-4xl uppercase tracking-tight">{title}</h1>
          <p className="font-body text-[#94A3B8] mt-2 mb-8">{sub}</p>
          {children}
        </div>
      </div>
    </div>
  );
}

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const res = await login(email, password);
    setLoading(false);
    if (res.ok) { toast.success("Welcome back"); nav("/dashboard"); }
    else toast.error(res.error);
  };

  return (
    <AuthShell title="Log In" sub="Access your fleet command center.">
      <form onSubmit={submit} className="space-y-5" data-testid="login-form">
        <div>
          <label className="il-label">Email</label>
          <input className="il-input" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required data-testid="login-email" placeholder="you@fleet.com" />
        </div>
        <div>
          <label className="il-label">Password</label>
          <input className="il-input" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required data-testid="login-password" placeholder="••••••••" />
          <div className="text-right mt-2">
            <Link to="/forgot-password" className="font-body text-sm text-[#94A3B8] hover:text-[#FFB800]" data-testid="goto-forgot-password">Forgot password?</Link>
          </div>
        </div>
        <button className="btn-signal w-full h-14 font-head text-lg" disabled={loading} data-testid="login-submit">{loading ? "Signing in…" : "Log In"}</button>
      </form>
      <p className="font-body text-[#94A3B8] mt-6 text-sm">No account? <Link to="/register" className="text-[#FFB800] font-700" data-testid="goto-register">Create a fleet →</Link></p>
    </AuthShell>
  );
}
